export const technologies = [
  {
    title: "Coldfusion Development",
    href: "/services/coldfusion-development",
  }, 
  {
    title: "ReactJS Developmentt",
    href: "/services/reactjs-development",
  }, 
  {
    title: "VueJS Development",
    href: "/services/vuejs-development",
  }, 
  {
    title: "Angular Development",
    href: "/services/angular-development",
  }, 
  {
    title: "NodeJS Development",
    href: "/services/nodejs-development",
  }, 
  {
    title: "Python Development",
    href: "/services/python-development",
  }, 
  {
    title: "Golang Development",
    href: "/services/golang-development",
  }, 
];